import emailjs from '@emailjs/browser';
import { useRef } from 'react';

export default function ConsultaPersonalizada() {
  const form = useRef<HTMLFormElement>(null);

  const enviarEmail = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const result = await emailjs.sendForm(
        'service_xep7hpt',      // Reemplaza con tu Service ID
        'template_55f84de',     // Reemplaza con tu Template ID
        form.current!,
        'u8LhoIe5CwjHOxOkG'       // Reemplaza con tu Public Key
      );

      console.log('✅ Email enviado:', result.text);
      alert('Gracias por tu interés. Ahora te llevamos al pago.');

      // Guardar email en localStorage
      const formData = new FormData(form.current!);
      const email = formData.get('email');
      localStorage.setItem('datosUsuario', JSON.stringify({ email }));

      window.location.href = '/pago';
    } catch (error: any) {
      console.error('❌ Error al enviar email:', error.text || error);
      alert('Hubo un problema al enviar tus datos. Intenta nuevamente.');
    }
  };

  return (
    <form ref={form} onSubmit={enviarEmail}>
      <label>Tu email:</label>
      <input type="email" name="email" required />
      <button type="submit">Registrarme</button>
    </form>
  );
}
